<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div style="width: 100%; margin-top: 10px">
      <div id="carousel-container">
        <carousel :perPage="1" :navigationEnabled="true" :navigationClickTargetSize="20" :paginationPadding="5" paginationColor="#dddddd" :paginationActiveColor="chatbotColors.sentMessage.bg">
          <slide v-for="(option, idx) in message.data.options" :key="idx">
            <div class="slide-container">
              <div class="plano" :style="{ color: chatbotColors.sentMessage.bg }">{{ option.plano }}</div>
              <div class="mensalidade">
                <strong>{{ option.valor_mensal }}</strong> / mês
              </div>
              <div class="beneficios">
                <div class="beneficios-title">ESTE PLANO POSSUI OS SEGUINTES BENEFÍCIOS:</div>
                <p v-for="(beneficio, idy) in option.beneficios" :key="idy">- {{ beneficio }}</p>
              </div>
              <button type="button" v-if="optionSelected === null" :disabled="lastMessage === false" @click.prevent="selectOption(option)" class="botao">GOSTEI DESTE</button>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import escapeGoat from 'escape-goat'
import store from "./../store/"

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      optionSelected: null
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    }
  },
  methods: {
    selectOption (option) {
      this.optionSelected = option;

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        editarFluxoInteracaoToken: this.$store.state.editarFluxoInteracaoToken,
        bot: true,
        data: { key: null, text: `${option.plano} - ${option.valor_mensal} / mês`, metadata: option }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
a.chatLink {
  color: inherit !important;
}
#carousel-container {
  width: 230px;
  margin-top: 10px;
}
.slide-container {
  padding: 21px;
  margin-right: 10px;
  border-radius: 30px;
  background: #f1f1f1;

  .plano {
    font-size: 1rem;
    font-weight: bold;
  }

  .mensalidade {
    font-size: .8rem;
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;

    strong {
      font-size: 1.3rem;
      color: #555;
    }
  }

  .beneficios {
    font-size: .7rem;
    padding-top: 15px;

    .beneficios-title {
      margin-bottom: 5px;
    }

    p {
      margin: 0;
    }
  }

  .botao {
    display: block;
    width: 100%;
    padding: 8px 15px;
    margin-top: 15px;
    border: 0;
    border-radius: 20px;
    font-size: 0.8rem;
    text-align: center;
    text-decoration: none;
    color: white;
    background: #61bd50;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }

    &:disabled {
      opacity: .7;
      cursor: default;
    }
  }
}
</style>
